import ztComponent from './ztInput.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
